import { Tree, message } from 'antd';
import React, { useState, useEffect } from 'react';
import { DownOutlined } from '@ant-design/icons';
import localStorage from '../../../utils/localStorage';

const { TreeNode } = Tree;

const HierarchyModal = (props) => {
  const [treeData, setTreeData] = useState(props.treeData || []);
  const [expandedKeys, setExpandedKeys] = useState([]);

  useEffect(() => {
    // Example of using localStorage to fetch initial data
    const storedModules = JSON.parse(localStorage.get('modules'));
    if (storedModules) {
      // Process storedModules if needed
    }
    setTreeData(props.treeData || []);
  }, [props.treeData]);

  // const renameProperty = (obj, oldName1, newName1, oldName2, newName2) => {
  //   if (obj && obj.children) {
  //     let children = obj.children.map((objChildren) => {
  //       return renameProperty(objChildren, oldName1, newName1, oldName2, newName2);
  //     });
  //     obj['children'] = children;
  //     obj[newName1] = obj[oldName1];
  //     delete obj[oldName1];
  //     obj[newName2] = obj[oldName2];
  //     delete obj[oldName2];
  //     return obj;
  //   } else {
  //     obj[newName1] = obj[oldName1];
  //     delete obj[oldName1];
  //     obj[newName2] = obj[oldName2];
  //     delete obj[oldName2];
  //     return obj;
  //   }
  // };

  // const getMenuHierarchyStructure = () => {
  //   if (treeData) {
  //     return treeData.map((userHierarchy) => {
  //       return renameProperty(userHierarchy, 'label', 'title', 'value', 'key');
  //     });
  //   }
  // };

  const getData = (item) => {
    const { Key, handleDropdownChange } = props;
    if (Key === 'Asset') {
      if (item && item.Type === 'Site') {
        message.error('Cant select site');
      } else if (item.Type !== 'Device') {
        handleDropdownChange(item);
      } else {
        message.error('Please select valid input');
      }
    } else {
      handleDropdownChange(item);
      getParent(item.Name, item.ParentId, treeData);
    }
  };

  const getParent = (Name, ParentId, treeData) => {
    let firstLevelParent = {};
    let children = [];
    let secondLevelParent = [];
    for (let i = 0; i < treeData.length; i++) {
      const node = treeData[i];
      if (node.children) {
        if (node.children.some((item) => item.Id === ParentId)) {
          firstLevelParent = node;
          children = node.children;
          if (children) {
            for (let i = 0; i < children.length; i++) {
              const childNode = children[i];
              if (childNode.children && childNode.children.length > 0) {
                if (childNode.Id === ParentId) {
                  secondLevelParent = childNode;
                }
              }
            }
          }
          if (props.handleParentNode) {
            props.handleParentNode(firstLevelParent, secondLevelParent);
          }
        } else if (getParent(Name, ParentId, node.children)) {
          getParent(Name, ParentId, node.children);
        }
      }
    }
    return firstLevelParent;
  };

  const renderTreeNodes = (data) => {
    return data.map((item) => {
      if (item.children && item.children.length > 0) {
        return (
          <TreeNode
            title={
              <div onClick={() => getData(item)}>
                {`${setTranslation(item.DisplayCode)} ${item.Name ? `(-${setTranslation(item.Name)})` : ''}`}
              </div>
            }
            key={item.key}
            dataRef={item}
          >
            {renderTreeNodes(item.children)}
          </TreeNode>
        );
      }

      return (
        <TreeNode
          key={item.key}
          title={
            <div onClick={() => getData(item)}>
              {`${setTranslation(item.DisplayCode)} ${item.Name ? `(-${setTranslation(item.Name)})` : ''}`}
            </div>
          }
          dataRef={item}
        />
      );
    });
  };

  const setTranslation = (keyword) => {
    const { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onExpand = () => {
    setExpandedKeys(expandedKeys);
  };

  return (
    <div
      style={{
        borderRight: '1px dashed white',
        width: '100%',
        flex: '35%',
        overflowY: 'auto',
        height: window.innerHeight - 250
      }}
    >
      <Tree
        style={{ color: 'white', backgroundColor: '#1a3652' }}
        showLine
        defaultExpandAll={true}
        switcherIcon={<DownOutlined />}
        onExpand={onExpand}
      >
        {renderTreeNodes(treeData)}
      </Tree>
    </div>
  );
};

export default HierarchyModal;